@if (isLogin) {
<app-login></app-login>
} @else {
<div class="main-opening">
  <div></div>

  <div class="logo-cindi">
    <img alt="Logo CINDI" src="../../../assets/images/logo cindi.svg" />
  </div>

  <div class="logo-sesi">
    <img alt="Logo SESI" src="../../../assets/images/Logo SESI.svg" />
  </div>
</div>
}
